<app-main-layout
  [clickNext]="onClickNext"
  [clickBack]="onClickBack"
  [activateNextButton$]="nextButtonState.activateNext$"
  >
  <div class="main-heading">
    <h2>Next, tell us why you want to replace your windows.</h2>
    <div class="cs-inner-html-16">
      <p>Please select all that apply.</p>
    </div>
  </div>
  <div class="selection-list">
    @for (item of selectionList; track item) {
      <app-selection-item
        [item]="item"
        (onItemClick)="selectItem(item)"
      ></app-selection-item>
    }
  </div>
  @if (!showOtherBlock) {
    <div class="text-link">
      <a (click)="switchOther(true, $event)" href="#">Other</a>
    </div>
  }
  @if (showOtherBlock) {
    <form [formGroup]="otherIssueForm">
      <div class="input">
        <button
          class="remove-btn"
          (click)="switchOther(false)"
          >
          <img
            class="icon"
            src="/assets/icons/trash-2.svg"
            alt="remove-btn"
            aria-hidden="true"
            />
        </button>
        <app-form-group
          label="Other"
          id="issue"
          [required]="true"
          [counter]="otherTextfieldMaxLength"
          formControlName="issue"
          placeholder="Enter your window issue here"
          >
        </app-form-group>
      </div>
    </form>
  }
</app-main-layout>
